import { render, staticRenderFns } from "./serveReturnFirst.vue?vue&type=template&id=5cd0301c&scoped=true&"
import script from "./serveReturnFirst.vue?vue&type=script&lang=js&"
export * from "./serveReturnFirst.vue?vue&type=script&lang=js&"
import style0 from "./serveReturnFirst.vue?vue&type=style&index=0&id=5cd0301c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cd0301c",
  null
  
)

export default component.exports